module.exports = __webpack_public_path__ + "img/iso.df031b0b.png";